<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <tr>
          <th v-for="column in columns" :key="column">{{column}}</th>
        </tr>
      </slot>
    </thead>
    <tbody>
    <tr v-for="(item, index) in data" :key="index">
      <td v-for="column in columns" :key="column">
        <a v-if="item.url" :href="`#/${item.url}/${item.id}`">{{ itemValue(item, column) }}</a>
        <span v-else>{{ itemValue(item, column) }}</span>
      </td>
    </tr>
    </tbody>
  </table>
</template>
<script>
  export default {
    props: {
      columns: Array,
      data: Array
    },
    methods: {
      hasValue (item, column) {
        return item[column.toLowerCase()] !== 'undefined'
      },
      itemValue (item, column) {
        return item[column.toLowerCase()]
      }
    }
  }
</script>
<style>
</style>
